import React, { Component } from 'react'
import { get } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"
import { withLoader } from "../../../shared/containers/containerLoader"

import { checkIsValidWorkTime } from "./static.workTimeData"
import ButtonFill from "../../../shared/items/controls/buttonFill"

class WorkTimeNextStepButton extends Component {
  componentDidUpdate() {
    const { data, onSetSuccessValidate } = this.props

    if (checkIsValidWorkTime(data))
      onSetSuccessValidate("workTime")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["workTime", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(withLoader(WorkTimeNextStepButton))